export default () => ({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    '& > button': { marginLeft: 10 }
  }
});
